import axios from 'axios';
import { AsyncSelect } from 'chakra-react-select';
import debounce from 'lodash.debounce';
import PropTypes, { object } from 'prop-types';

function SelectUserInput({ value, isMulti, isClearable, onChangeHandler }) {
  const loadUsers = debounce((inputValue, callback) => {
    axios
      .get(`/graph/users?query=${inputValue.trim()}`)
      .then((response) => {
        callback(
          response.data?.map((item) => ({
            label: item.name,
            value: item.email,
          }))
        );
      })
      .catch(() => {
        callback([]);
      });
  }, 1000);

  return (
    <AsyncSelect
      placeholder="Search user by name or email"
      loadOptions={loadUsers}
      value={value}
      onChange={(setter) => onChangeHandler(setter)}
      isMulti={isMulti}
      isClearable={isClearable}
    />
  );
}

SelectUserInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(object)])
    .isRequired,
  isMulti: PropTypes.bool.isRequired,
  isClearable: PropTypes.bool.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};

export default SelectUserInput;
